import { modalNames } from '../../../shared/configs/modal';
import { searchParamKeys, viewMap } from '../../../shared/configs/searchParams';

const resetedStateKeys = [
  'registerAvailabilityState',
  'addressState',
  'ownersState',
  'selectedOwnerState',
];

export class SelectOwnerModalHandlers {
  constructor(controller) {
    this.controller = controller;
    this.onOk = this.onOk.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.afterClose = this.afterClose.bind(this);
  }

  onCancel() {
    const { searchParams, modal } = this.controller;
    searchParams.setParams({ [searchParamKeys.detailsPageMode]: undefined });
    modal.close(modalNames.selectOwnerForRegistration);
  }

  onOk() {
    const { searchParams, modal, registerAvailabilityState } = this.controller;
    const { status } = registerAvailabilityState.state.payload;

    switch (status) {
      case 'success': {
        this.event = 'transition';

        modal.close(modalNames.selectOwnerForRegistration);

        searchParams.setParams({ [searchParamKeys.view]: viewMap.calendar });

        break;
      }

      default: {
        this.onCancel();
      }
    }
  }

  afterClose = () => {
    if (this.event !== 'transition') {
      resetedStateKeys.forEach((key) => {
        this.controller[key].reset();
      });
    }
  };

  get handlers() {
    return {
      onOk: this.onOk,
      onCancel: this.onCancel,
      afterClose: this.afterClose,
    };
  }
}
